import React from 'react';
import ScrollableContainer from 'components/shared/scrollable';

class DemonstrationGradersCollection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graders: this.props.graders,
    };
  }

  fetchData() {
    return new Promise.resolve(data => {
      this.setState(state => ({
        graders: [...state.graders, ...data.graders.name],
      }));
    });
  }

  render() {
    const { graders } = this.state;
    return (
      <ScrollableContainer
        className="DemonstrationGradersModal-scrollable bg-white pr-0"
        maxHeight={null}
      >
        <ul>
          {graders &&
            graders.map(g => (
              <li
                key={g.id}
                className="h-bc-gray-lightest py-16 d-f jc-sb pl-32 pr-58 ContentItem--list"
              >
                <span className="DemonstrationGradersModal-count pr-40 fz-16">
                  {g.name}
                </span>
              </li>
            ))}
        </ul>
      </ScrollableContainer>
    );
  }
}

export default DemonstrationGradersCollection;
